import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Loader from "../Loader";

import Styles from "./styles.module.scss";

const LoaderOverlay = ({ loading, children, className }) => (
  <div className={classNames(Styles.Container, className)}>
    {children}
    {loading && (
      <div className={Styles.Overlay}>
        <Loader />
      </div>
    )}
  </div>
);

LoaderOverlay.propTypes = {
  /**
   * When true, block children UI and show Loader
   */
  loading: PropTypes.bool,
  /**
   * Any renderable children
   */
  children: PropTypes.node,
  /** Classes to apply to the parent wrapping div */
  className: PropTypes.string
};

LoaderOverlay.defaultProps = {
  loading: false
};

export default LoaderOverlay;
